import type { SearchResult } from '@backstage/plugin-search-common';

/**
 * Resolves the navigation path for a search result.
 *
 * Catalog template entities live at /catalog/{namespace}/template/{name} but
 * are best explored via the scaffolder UI at /create/templates/{namespace}/{name}.
 * This function rewrites those URLs so that activating a template result lands
 * on the scaffolder page rather than the raw catalog entity page.
 *
 * All other result locations are returned unchanged.
 */
export function resolveLocation(result: SearchResult): string {
  const loc = result.document.location;
  // Match /catalog/{namespace}/template/{name} and rewrite to scaffolder.
  const m = loc.match(/^\/catalog\/([^/]+)\/template\/([^/]+)/);
  if (m) return `/create/templates/${m[1]}/${m[2]}`;
  return loc;
}
